import { render } from "./MemberHeader0.vue?vue&type=template&id=1a24b042&scoped=true"
import script from "./MemberHeader0.vue?vue&type=script&lang=js"
export * from "./MemberHeader0.vue?vue&type=script&lang=js"

import "./MemberHeader0.vue?vue&type=style&index=0&id=1a24b042&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a24b042"]])

export default __exports__